import React, { useState, useEffect } from "react";
import classNames from "classnames";
import validUrl from "valid-url";
import SmallHeading from "../../SmallHeading/SmallHeading";
import MainHeading from "../../MainHeading/MainHeading";
import FindBlogExists from "../../../checks/FindBlogExists";
import DOMCheck from "../../../checks/DOMCheck";
import AuthHelper from "../../../helper/AuthHelper";
import ValidatePost from "../../../checks/ValidatePost";
import ValidateAccount from "../../../checks/ValidateAccount";
import AjaxCheck from "../../../checks/AjaxCheck";
import useKeyPress from "../../../helper/UseKeyPress";
import ImageCheck from "../../../checks/ImageCheck";

const Body = (props) => {
  const [loading, setLoading] = useState(false);
  const [secondaryText, setSecondaryText] = useState("");
  const [blogUrl, setBlogUrl] = useState("");
  const encodedURL = btoa(encodeURIComponent(blogUrl));
  const pressedEnter = useKeyPress("Enter");

  useEffect(() => {
    if (pressedEnter) {
      if (blogUrl.length > 0) {
        nextClickHandler();
      }
    }
  }, [pressedEnter]);

  const inputChangedHandler = (e) => setBlogUrl(e.target.value);
  const nextClickHandler = () => {
    setLoading(true);
    setSecondaryText("");
    FindBlogExists(blogUrl)
      .then((id) => {
        if (AuthHelper.getUserToken()) {
          const completedTasks = [];
          let errors;
          let postName;

          ValidatePost(id)
            .then((msg) => {
              completedTasks.push(msg.message);
              postName = msg.postName;
            })
            .then(() => ValidateAccount())
            .then((msg) => {
              completedTasks.push(msg);
            })
            .then(() => ImageCheck(blogUrl))
            .then((msg) => completedTasks.push(msg))
            .then(() => DOMCheck(blogUrl))
            .then((msg) => completedTasks.push(msg))
            .then(() => AjaxCheck(blogUrl))
            .then((msg) => completedTasks.push(msg))
            .catch((err) => {
              console.log(err);
              errors = err;
            })
            .finally(() => {
              // console.log(completedTasks);
              // console.log(errors);

              props.history.push({
                pathname: `/summary/${encodedURL}/${id}`,
                state: {
                  completedTasks,
                  errors,
                  postName
                }
              });
            });
        } else {
          props.history.push(`/login/${encodedURL}/${id}`);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err === "Invalid URL") {
          setLoading(false);
          setSecondaryText("Invalid URL");
        } else {
          props.history.push(`/not-found/${encodedURL}`);
        }
      });
  };

  const buttonClassName = classNames(
    "text-white text-xl font-bold py-2 px-4 rounded  w-1/5 text-center h-16 ",
    { narrativeGradient: !loading },
    { narrativeGradientClicked: loading }
  );

  const buttonChildren = loading ? (
    <div id="loading" />
  ) : (
    <span className="graphikFont">Next</span>
  );

  const checkingText = loading && (
    <div className="mt-8">
      <span className="graphikFont" style={{ color: "rgba(26, 26, 26, 0.45)" }}>
        Checking URL
      </span>
    </div>
  );

  const invalidURLText = secondaryText.length > 0 && (
    <div className="mt-8">
      <span className="graphikFont" style={{ color: "rgba(26, 26, 26, 1.00)" }}>
        {secondaryText}
      </span>
    </div>
  );

  return (
    <div className="w-full mt-12">
      <MainHeading heading="Trouble with your Narrative post?" />
      <SmallHeading heading="Input the blog post URL to run a post check" />
      <div className="mt-24">
        <input
          className="inputBorder graphikFont w-1/5 text-sm"
          placeholder="www.yourwebsite.com/blog/my-post"
          onChange={inputChangedHandler}
          disabled={loading}
        />
      </div>
      <div className="mt-12">
        <button
          onClick={nextClickHandler}
          className={buttonClassName}
          disabled={loading || blogUrl.length === 0}
        >
          {buttonChildren}
        </button>
        {checkingText}
        {invalidURLText}
      </div>
    </div>
  );
};

export default Body;
